import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, map, filter } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';


@Injectable()
export class CrumbsService {
    public crumbs = new BehaviorSubject([]);
    constructor(private router: Router, private route: ActivatedRoute) {
        console.log('laying breadcrumb trail');
        router.events.pipe(
            filter(v => v instanceof NavigationEnd),
            distinctUntilChanged(),
            map(v => {
                const parsedUrl = this.router.parseUrl(this.router.url).root;
                if (!parsedUrl.children['primary']) {
                    return [];
                }
                const parts = parsedUrl.children['primary'].segments.map(v => v.path);
                return parts.map((part, idx) => {
                    return {label: this.humanReadable(part), url: '/' + parts.slice(0, idx).concat(part).join('/')};
                });
            })
        ).subscribe(this.crumbs);
    }
    humanReadable(part) {
        return part.split('_').map(v => `${v.slice(0, 1).toUpperCase()}${v.slice(1)}`).join(' ');
    }
}
